<template>
	<div class="header-nav">
		<div class="menu-icon" @click="toggleOverLay" v-if="!backOrMenuIcon">
		</div>
		<div class="back-icon" @click="backToFirstLevelComment" v-if="backOrMenuIcon">&lt;</div>
		<router-link to="/" class="home-logo" tag="div"></router-link>
		<div class="login-box">
			<div class="user-phone-info" v-if="loginStatus" @click="logoutBtn = !logoutBtn">
				{{ penName && penName.length > 5 ? penName.substring(0, 5) + '...' : penName }}
				<van-icon name="arrow-down" v-if="!logoutBtn" />
				<van-icon name="arrow-up" v-if="logoutBtn" />
				<div class="logout-btn" v-if="logoutBtn" @click="logout">
					退出登录
				</div>
			</div>
			<router-link to="/login" class="login-btn" v-if="loginOrRegister && !loginStatus">登录</router-link>
			<router-link :to="{ name: 'register', params: { pageType: 'register' } }" class="login-btn"
				v-if="!loginOrRegister && !loginStatus">注册</router-link>
		</div>
		<div :style="visibility" @click="toggleOverLay" class="overlay">
			<div class="wrapper">
				<span class="close-mask" @click.stop="toggleOverLay"><i>x</i></span>
				<ul>
					<router-link to="/" tag="li" :exact="true">首页</router-link>
					<router-link :to="{ name: 'scriptlist' }" tag="li" exact>剧本专区</router-link>
					<router-link class="to-user-center" :to="{ name: 'usercenter' }" tag="li" exact>个人中心<span
							class="new-msg-tag" v-if="hasUnreadMsg >= 0"></span></router-link>
					<router-link :to="{ name: 'uploadintro' }" tag="li" exact>作品上传</router-link>
					<router-link :to="{ name: 'feedback' }" tag="li" exact>意见反馈</router-link>
					<router-link :to="{ name: 'aboutus' }" tag="li" exact>关于我们</router-link>
					<router-link :to="{ name: 'policy' }" tag="li" exact>隐私政策</router-link>
					<router-link :to="{ name: 'contactus' }" tag="li" exact>联系我们</router-link>
					<!-- <router-link :to="{name:'vogue'}" tag="li" exact>爆款测试入口</router-link> -->
					<li @click="logout" v-if="loginStatus">退出</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { GetCookie, DelCookie } from '@/assets/api/cookie'
import { Axios, AxiosOldByToken } from '@/assets/api/axios'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
	name: 'HeaderNav',
	data() {
		return {
			visibility: "visibility:hidden",
			loginOrRegister: true,                //根据所在页面判断导航上显示注册还是登录
			loginStatus: false,                   //判断登录状态 登录成功显示用户手机号信息
			show: false,                          //导航弹出遮罩显示隐藏
			logoutBtn: false,                     //切换推出登录按钮显示隐藏状态
			penName: '',                         //登录成功后显示用户笔名
			msgStatusArr: [],                     //储蓄消息状态
			hasUnreadMsg: -1,                     //判断是否有未读消息
			backOrMenuIcon: false                    //控制在二级评论页时显示返回按钮

		}
	},
	watch: {
		//根据路由名称控制导航栏显示登录还是注册
		$route: {
			handler: function (to, from) {
				this.toggleLogin(to.name)
				if (GetCookie('token')) {
					this.penName = GetCookie('pn')
					this.loginStatus = true
				}
				if (to.name == "seccomment") {
					this.backOrMenuIcon = true
				} else {
					this.backOrMenuIcon = false
				}
			}
		}
	},
	mounted() {
		let body = document.querySelector('body')
		body.addEventListener('touchstart', (e) => {
			if (e.target.getAttribute('class') == "logout-btn") {
				return false
			} else {
				this.logoutBtn = false
			}
		}, false)
	},
	created() {
		if (GetCookie('token')) {
			this.penName = GetCookie('pn')
			this.loginStatus = true
		}
		if (this.$route.name == "login") {
			this.loginOrRegister = false
		}
		if (GetCookie('token')) {
			Axios.defaults.headers.common['Authorization'] = GetCookie('token')
			Axios.get('/user/message', { params: { page: 0, num: 20 } })
				.then(
					response => {
						if (response.data.code == 200 && response.data.status == "success") {
							this.loginStatus = true
							for (let i = 0; i < response.data.data.lists.length; i++) {
								this.msgStatusArr.push(response.data.data.lists[i].status)
							}
							this.hasUnreadMsg = this.msgStatusArr.indexOf(0)
						}
					}
				).catch(
					error => {
						if (error.response.data.code == 422) {
							DelCookie('token')
							DelCookie('phone')
							DelCookie('real_auth')
							DelCookie('pn')
							this.$swal({
								text: '未登录或登录超时 请重新登录',
								showConfirmButton: false,
								width: '6rem',
								padding: '0.5rem',
								timer: 1100,
								imageWidth: 50,
								imageHeight: 50,
								imageUrl: notifyIcon,
								timerProgressBar: true
							})
							setTimeout(() => {
								location.href = '/login'
							}, 1100)
						}
					}
				)
		}
	},
	methods: {
		toggleOverLay() {
			if (this.visibility == "visibility:visible") {
				this.visibility = "visibility:hidden";
			} else {
				this.visibility = "visibility:visible";
			}
		},
		//根据路由所在页面切换登录注册显示哪一个
		toggleLogin(name) {
			//注册/密码重置/绑定手机时导航栏显示注册
			if (name == "login" || name == "pswreset" || name == "bindphone") {
				this.loginOrRegister = false
			} else {
				this.loginOrRegister = true
			}
		},
		logout() {
			AxiosOldByToken.defaults.headers.common['Authorization'] = GetCookie('token')
			AxiosOldByToken.post('/logout').then(
				response => {
					if (response.data.code == "200" && response.data.status == "success") {
						DelCookie('token')
						DelCookie('phone')
						DelCookie('real_auth')
						DelCookie('pn')
						this.loginStatus = false
					}
				}
			).catch(
				error => {
					DelCookie('token')
					DelCookie('phone')
					DelCookie('real_auth')
					DelCookie('pn')
					this.loginStatus = false
				}
			)
		},
		backToFirstLevelComment() {
			location.href = "/allcomment?id=" + this.$route.query.id
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.router-active {
	font-weight: bold;
	color: #bf0000 !important;
	font-size: 30px !important;
}

.header-nav {
	width: 750px;
	height: 88px;
	background: #282828;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 10000000000000;

	.overlay {
		z-index: 9999999;
		height: 100%;
		position: fixed;
		background: rgba(0, 0, 0, .6)
	}

	.wrapper {
		width: 100%;
		height: 100%;
		-webkit-overflow-scrolling: touch;
		overflow-y: scroll;

		ul {
			width: 550px;
			padding: 50px 100px;

			li {
				padding: 36px 0;
				color: #fff;
				border-bottom: 1px solid #fff;
				font-size: 28px;
			}

			li:last-child {
				border-bottom: none;
			}
		}

		.to-user-center {
			position: relative;
		}

		.new-msg-tag {
			position: absolute;
			width: 14px;
			height: 14px;
			border-radius: 50%;
			background: #bf0000;
			left: 110px;
			top: 30px;
		}

		.close-mask {
			position: absolute;
			height: 88px;
			line-height: 88px;
			width: 100%;
			display: inline-block;
			color: #fff;
			border-bottom: 1px solid #fff;
			position: relative;

			i {
				font-size: 40px;
				position: absolute;
				right: 40px;
			}
		}
	}

	.menu-icon,
	.home-logo,
	.login-box {
		position: absolute;
	}

	.back-icon {
		color: #f7f7f7;
		font-size: 40px;
		position: absolute;
		left: 24px;
		top: 22px;
	}

	.menu-icon {
		width: 30px;
		height: 25px;
		left: 24px;
		top: 32px;
		background: url('../assets/img/navmenuicon2x.png') no-repeat;
		background-size: 100% 100%;
	}

	.home-logo {
		height: 38px;
		// top: 25px;
		// width: 188px;
		// left: 281px;
		// background: url('../assets/img/logo3.png') no-repeat;
		width: 238px;
		left: 256px;
		top: 27px;
		background: url('../assets/img/2022/yslg.png') no-repeat;
		background-size: 100% 100%;
	}

	.login-box {
		top: 32px;
		right: 25px;
		height: 24px;

		.login-btn {
			font-size: 24px;
			color: #fff;
			vertical-align: top;
		}

		.van-icon {
			transform: translateY(4px);
			margin-left: 4px;
		}

		.user-phone-info {
			font-size: 24px;
			color: #fff;
			position: relaitve;

			.logout-btn {
				position: absolute;
				right: 0;
				top: 58px;
				width: 120px;
				height: 60px;
				line-height: 60px;
				text-align: center;
				background: #333;
				border-top: 3px solid #bf0000;
			}
		}
	}
}
</style>
